module.exports = __webpack_public_path__ + "img/pto.8b3d3e9c.svg";